import { h } from '../lib/dom.js';
import { getState, setSilent } from '../store.js';
import { cancelAddRecipient, saveRecipient, setRecipientEditField, validateRecipientAddressBlur } from '../actions.js';

export function renderAddRecipientModal() {
  const s = getState();
  if (!s.showAddRecipient) return null;
  const editing = s.recipientEdit;
  const nameValue = editing ? editing.name : s.newRecipName;
  const addressValue = editing ? editing.address : s.newRecipAddress;
  const onNameInput = editing
    ? (e) => setRecipientEditField('name', e.target.value)
    : (e) => setSilent({ newRecipName: e.target.value });
  const onAddressInput = editing
    ? (e) => setRecipientEditField('address', e.target.value)
    : (e) => setSilent({ newRecipAddress: e.target.value });

  return h('div', { class: 'modal-scrim' }, [
    h('div', { class: 'modal-card' }, [
      h('div', { class: 'modal-title' }, editing ? 'Edit recipient' : 'Add new account'),
      h('input', { placeholder: 'Name', value: nameValue, oninput: onNameInput, onkeydown: (e) => { if (e.key === 'Enter') saveRecipient(); } }),
      h('input', {
        placeholder: 'Wallet address', value: addressValue, class: 'mono', oninput: onAddressInput,
        onblur: validateRecipientAddressBlur, onkeydown: (e) => { if (e.key === 'Enter') saveRecipient(); }
      }),
      h('div', { class: 'field-error' }, s.newRecipError || ''),
      h('div', { class: 'btn-row' }, [
        h('button', { class: 'btn btn-secondary', onclick: cancelAddRecipient }, 'Cancel'),
        h('button', { class: 'btn btn-primary', onclick: saveRecipient }, editing ? 'Save changes' : 'Save')
      ])
    ])
  ]);
}
